import { InstallPicker } from "./InstallPicker";
import { Modal } from "./Modal";
import { LinkButton } from "../design";

/** The install command on demand, for a second machine or a missed setup. */
export function InstallDialog({ onClose }: { onClose: () => void }) {
  return (
    <Modal
      title="Install the CLI"
      onClose={onClose}
      wide
      footer={
        <LinkButton
          variant="link"
          size="sm"
          href="/?setup=1"
          iconRight="arrow-up-right"
        >
          Setup guide
        </LinkButton>
      }
    >
      <div className="per-install-dialog">
        <p className="per-muted">
          Run this in a terminal on any machine. It installs dense and signs it
          in to this account; then start your agent with{" "}
          <code>dense claude</code>, <code>dense codex</code> or{" "}
          <code>dense opencode</code>.
        </p>
        <InstallPicker seen onSeen={() => {}} />
      </div>
    </Modal>
  );
}
